"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertTypeRow = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const hooks_1 = require("material-ui-popup-state/hooks");
const react_1 = require("react");
const type_selector_1 = require("./insert-property-row/type-selector");
const with_handler_1 = require("./with-handler");
const InsertTypeRow = ({ inputRef, onCancel, onAdd, variant, createModalPopupState, searchText, onSearchTextChange, options, }) => {
    const ourInputRef = (0, react_1.useRef)(null);
    const sharedRef = (0, material_1.useForkRef)(inputRef, ourInputRef);
    return ((0, jsx_runtime_1.jsx)(material_1.TableRow, { sx: {
            [`.${material_1.tableCellClasses.root}`]: {
                py: 1,
            },
        }, children: (0, jsx_runtime_1.jsx)(material_1.TableCell, { colSpan: 2, children: (0, jsx_runtime_1.jsx)(type_selector_1.TypeSelector, { searchText: searchText, onSearchTextChange: onSearchTextChange, inputRef: sharedRef, createModalPopupState: createModalPopupState, onAdd: onAdd, onCancel: onCancel, options: options, dropdownProps: {
                    query: searchText,
                    createButtonProps: createModalPopupState
                        ? {
                            ...(0, with_handler_1.withHandler)((0, hooks_1.bindTrigger)(createModalPopupState), () => {
                                ourInputRef.current?.focus();
                            }),
                            onMouseDown: (evt) => {
                                evt.preventDefault();
                                evt.stopPropagation();
                            },
                        }
                        : null,
                    variant: variant === "property" ? "propertyType" : "linkType",
                }, variant: variant }) }) }));
};
exports.InsertTypeRow = InsertTypeRow;
